// src/pages/Home.jsx
import React from 'react';
import Header from '../components/Header';
import Hero from '../components/LandingPage/Hero';
import Benefits from '../components/LandingPage/Benefits';
import HowItWorks from '../components/LandingPage/HowItWorks';
import Examples from '../components/LandingPage/Examples';
import Testimonials from '../components/LandingPage/Testimonials';
import Pricing from '../components/LandingPage/Pricing';
import Faq from '../components/LandingPage/Faq';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <>
      <Header />
      <Hero />
      <Benefits />
      <HowItWorks />
      <Examples />
      <Testimonials />
      <Pricing />
      <Faq />
      <Footer />
    </>
  );
};

export default Home;